import React, { useLayoutEffect, useState } from "react";
import ReactDOM from "react-dom";

interface PortalProps {
  children: React.ReactNode;
}

const PORTAL_ID = "portal-root";

const Portal = ({ children }: PortalProps) => {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (typeof document !== "undefined") {
      const element = document.getElementById(PORTAL_ID);
      setTarget(element);
    }
  }, []);

  return target ? ReactDOM.createPortal(children, target) : null;
};

export default Portal;
